import Vue from 'vue';

//import { createRule, createAudiencesRepository } from './CustomAudienceClasses.js';
// var Audience = () => import('./CustomAudienceClasses.js');

const storePrefix = "events_custom_audience_store_";

const caRulesUrls = {
    getAudiences: '../Discovery/Service.asmx.cs/getAudiences'
};



const typeRule = ({

    ruleId = null, // UUID
    dirtyRuleId = null, // UUID
    sectionId = null,
    audienceId = null,  // UUID
    selectedActionItem = null,
    selectedEventItem = null,
    selectedDays = 7

} = {}) => ({

    ruleId,     // UUID
    dirtyRuleId,   // UUID
    sectionId,
    audienceId, // UUID
    selectedActionItem,
    selectedEventItem,
    selectedDays,
    //selectedEqualityItem: null,
    //selectedTimes: null,

    loadData(data, callback) {

        this.ruleId = data.ruleId,
        this.dirtyRuleId = data.dirtyRuleId;
        this.sectionId = data.sectionId;
        this.audienceId = data.audienceId;
        this.selectedActionItem = data.selectedActionItem;
        this.selectedEventItem = data.selectedEventItem;
        this.selectedDays = data.selectedDays;
    },

    propNotValid(prop) {

        let valid = false;

        switch (prop) {

            case 'selectedActionItem':
                valid = typeof this.selectedActionItem === 'number';
                break;

            case 'selectedEventItem':
                valid = typeof this.selectedEventItem === 'number';
                break;

            case 'selectedDays':
                valid = typeof this.selectedDays === 'number' && this.selectedDays > 0 && this.selectedDays <= 30;
                break;

            default:
                valid = false;
                break;

        }

        return valid === false;
    },

    ruleIsValid() {

        let valid = true;

        ['selectedActionItem', 'selectedEventItem', 'selectedDays'].forEach(key => {
            if (this.propNotValid(key))
                valid = false;
        });

        return valid;

    }

});

var typeAudience = ({

    audienceId = null,      // UUID
    audienceDirtyId = null,      // UUID
    audienceName = null,
    audienceApps = null,
    audienceRange = null,
    audienceReach = null,
    audienceMaxReach = null,
    audienceOperator = '',
    audienceInternalOperator = '',
    audienceExternalOperator = '',
    audienceIsDirty = false,
    //audienceRules = [{ ...typeRule() }],
    audienceRules = [],
    audienceDescription = '',
    nextDirtyRuleId = 0      // UUID


} = {}) => ({

    audienceId,      // UUID
    audienceName,
    audienceApps,
    audienceRange,
    audienceReach,
    audienceMaxReach,
    audienceOperator,
    audienceInternalOperator,
    audienceExternalOperator,
    audienceIsDirty,
    audienceRules,

    nextDirtyRuleId,      // UUID

    loadData(data, callback) {

        this.audienceId = data.audienceId;
        this.audienceName = data.audienceName;
        this.audienceApps = data.audienceApps;
        this.audienceRange = data.audienceRange;
        this.audienceReach = data.audienceReach;
        this.audienceMaxReach = data.audienceMaxReach;
        this.audienceOperator = data.audienceOperator;
        this.audienceInternalOperator = data.audienceOperator;
        this.audienceExternalOperator = data.audienceOperator ? data.audienceOperator === 'OR' ? 'AND' : 'OR' : '';
        this.audienceIsDirty = data.audienceIsDirty;

        let _rules = [];
        data.audienceRules.forEach((rule, index, audArr) => {
            let _rule = typeRule();
            _rule.loadData(rule);
            _rules.push(_rule);
        });
        this.audienceRules = _rules;
        //this.audienceDescription = this.getDescription();
    },

    getNextDirtyRuleId() {
        return this.nextDirtyRuleId;
    },

    setNextDirtyRuleId() {
        this.nextDirtyRuleId = Utils.RandomUUID();
    },

    getNextSectionId() {
        return this.audienceRules && this.audienceRules.length > 0 ? Math.max.apply(Math, this.audienceRules.map(function (o) { return o.sectionId || 1; })) + 1 : 1;
    },

    set: (audience, callback) => {
        callback();
    },

    audienceIsValid() {

        let rulesValid = this.audienceRulesAreValid();
        let nameIsValid = this.audienceName ? true : false;

        return rulesValid && nameIsValid;

    },

    audienceRulesAreValid() {

        let has_rules = this.audienceRules && this.audienceRules.length > 0;
        let all_rules_valid = has_rules ? this.audienceRules.filter(r => r.ruleIsValid() === false).length === 0 : false;

        return all_rules_valid;
    },

    getDescription() {
        return this.getAudienceDescription(this);
    },

    getAudienceDescription(aud) {

        let actions = JSON.parse(model.eventsCustomAudienceObj.cdc_events_custom_audience_action_json);
        let apps = JSON.parse(model.eventsCustomAudienceObj.cdc_events_custom_audience_target_apps_json);
        let _events = JSON.parse(model.eventsCustomAudienceObj.cdc_events_custom_audience_events_json);
        let __events = _events.filter((ev, i, arr) => {
            return rr.findIndex(t => t.id === ev.id) === i;
        });
        let events = __events.map(event_ => {
            const { pba_id, ...event_without_pba_id } = event_;
            return event_without_pba_id;
        });


        let inner_op_str = aud.audienceInternalOperator;
        let exter_op_str = aud.audienceExternalOperator;

        let apps_str = apps.find(a => a.id === aud.audienceApps).name;

        let sections = [...new Set(aud.audienceRules.map(r => r.sectionId))];

        let _rules = aud.audienceRules.map(r => {
            let action_str = actions.find(a => a.id === r.selectedActionItem).name.replace("'", "\'");
            let event_str = events.find(a => a.id === r.selectedEventItem).name;
            let days_str = r.selectedDays;

            return {
                sectionId: r.sectionId,
                ruleStr: action_str + " " + event_str + " " + " during the last " + days_str + " days"
            };
        });

        let strDescRows = [];
        strDescRows.push("Based on events from " + apps_str.replace("'", "\'") + ", Users who");

        sections.forEach((section, sindex, sections) => {
            let secRules = _rules.filter(r => r.sectionId === section);
            secRules.forEach((srule, rindex, srules) => {
                strDescRows.push(srule.ruleStr);
                if (rindex < srules.length - 1)
                    strDescRows.push(inner_op_str);
            });
            if (sindex < sections.length - 1) strDescRows.push(exter_op_str);
        });

        return strDescRows; 
    },

    getAudienceReachObj() {

        let aud = this;

        let events = JSON.parse(model.eventsCustomAudienceObj.cdc_events_custom_audience_events_json);

        const _getMinInt = arr => arr && arr.length ? arr.reduce((max, value) => value > max ? max : value) : 0;
        const _getMaxInt = arr => arr && arr.length ? arr.reduce((max, value) => value > max ? value : max) : 0;
        const _sumIntArr = arr => arr && arr.length ? arr.reduce((total, value) => total + value) : 0;


        let inner_op_str = aud.audienceInternalOperator ? aud.audienceInternalOperator.toLowerCase() : aud.audienceInternalOperator;
        let exter_op_str = aud.audienceExternalOperator ? aud.audienceExternalOperator.toLowerCase() : aud.audienceExternalOperator;

        let apps_id = aud.audienceApps;

        let section_ids = [...new Set(aud.audienceRules.map(r => r.sectionId))];

        let _rules = aud.audienceRules.map(r => {
            let action_id = r.selectedActionItem;
            let days = r.selectedDays;
            let event_ = events.find(a => a.id === r.selectedEventItem);

            return {
                sectionId: r.sectionId,
                actionId: action_id,
                ruleReach: (event_ ? event_.reach : 0) * Math.floor(days / 7)   //action_id === 1 ? (event_.reach * days) : (event_.max_reach - event_.reach * days)
            };
        });

        let sections = [];

        section_ids.forEach((section) => {
            let secRules = _rules.filter(r => r.sectionId === section);
            sections.push(secRules);
        });


        let reach = aud.audienceReach || 0;

        if (reach === 0) {

            let sectionReach = [];
            sections.forEach((sectionRules) => {

                let _sectionReach = 0;

                let didActions = sectionRules.filter(sr => sr.actionId === 1);
                let didntActions = sectionRules.filter(sr => sr.actionId === 0);

                if (didActions.length > 0) {

                    if (inner_op_str === "and") {
                        let didActionsReach = didActions.map(d => d.ruleReach);
                        _sectionReach = _getMinInt(didActionsReach);
                    }
                    else {
                        let didActionsReach = didActions.map(d => d.ruleReach);
                        _sectionReach = _sumIntArr(didActionsReach);
                    }
                }
                else {

                    if (inner_op_str === "and") {
                        let didntActionsReach = didntActions.map(d => d.ruleReach);
                        _sectionReach = -1 * _getMinInt(didntActionsReach);
                    }
                    else {
                        let didntActionsReach = didntActions.map(d => d.ruleReach);
                        _sectionReach = -1 * _sumIntArr(didntActionsReach);
                    }

                }

                sectionReach.push(_sectionReach);
            });


            let interSectionReach_did = sectionReach.filter(sr => sr > -1);
            let interSectionReach_didnt = sectionReach.filter(sr => sr < 0);

            if (interSectionReach_did.length > 0) {

                if (exter_op_str === "and") {
                    reach = _getMinInt(interSectionReach_did);
                }
                else {
                    reach = _sumIntArr(interSectionReach_did);
                }

            }
            else {

                if (exter_op_str === "and") {
                    reach = aud.audienceMaxReach + _getMinInt(interSectionReach_didnt);
                }
                else {
                    reach = aud.audienceMaxReach + _sumIntArr(interSectionReach_didnt);
                }

            }
        }

        let precentage = Math.floor(reach * 100 / aud.audienceMaxReach);

        return {
            reach: reach,
            max_reach: aud.audienceMaxReach,
            precentage: precentage,
            level: precentage > 70 ? "too broad" : precentage < 30 ? "too narrow" : "fairly broad"
        };


        //return {

        //    apps: apps_id,
        //    sections: _sections,
        //    inner_op_str: inner_op_str,
        //    exter_op_str: exter_op_str

        //};


    },

    getAudienceDescriptionObj() {

        let aud = this;

        let actions = JSON.parse(model.eventsCustomAudienceObj.cdc_events_custom_audience_action_json);
        let events = JSON.parse(model.eventsCustomAudienceObj.cdc_events_custom_audience_events_json);
        let apps = JSON.parse(model.eventsCustomAudienceObj.cdc_events_custom_audience_target_apps_json);

        let inner_op_str = aud.audienceInternalOperator;
        let exter_op_str = aud.audienceExternalOperator;

        let apps_str = apps.find(a => a.id === aud.audienceApps).name;

        let sections = [...new Set(aud.audienceRules.map(r => r.sectionId))];

        let _rules = aud.audienceRules.map(r => {
            let action_str = actions.find(a => a.id === r.selectedActionItem).name.replace("'", "\'");
            let _event = events.find(a => a.id === r.selectedEventItem);
            let event_str = _event ? _event.name : '---';
            let days_str = r.selectedDays;

            return {
                sectionId: r.sectionId,
                ruleStr: action_str + " " + event_str + " " + " during the last " + days_str + " days"
            };
        });

        let strDescRows = [];
        strDescRows.push("Based on events from " + apps_str.replace("'", "\'") + ", Users who");

        let _sections = [];

        sections.forEach((section, sindex, sections) => {
            let secRules = _rules.filter(r => r.sectionId === section);
            _sections.push(secRules);
        });


        return {

            apps: apps_str,
            sections: _sections,
            inner_op_str: inner_op_str,
            exter_op_str: exter_op_str

        };


        //secRules.forEach((srule, rindex, srules) => {
        //    strDescRows.push(srule.ruleStr);
        //    if (rindex < srules.length - 1)
        //        strDescRows.push(inner_op_str);
        //});
        //if (sindex < sections.length - 1) strDescRows.push(exter_op_str);


        // return strDescRows; 
    },

    getAudienceReach() {

        // if (this.audienceRulesAreValid() === false) {
        //     return { min: 0, max: 0 };
        // }

        let validAudienceRules = this.audienceRules.filter(a  => a.ruleIsValid());

        if (validAudienceRules.length === 0) {
            return {
                level: null,
                precentage: 0,
                reach: 0
            };
        }

        let __reachObj = this.getAudienceReachObj();

        
        let _reach =  {
            level: __reachObj.level,
            precentage: __reachObj.precentage || 0,
            reach: __reachObj.reach || 0
        };

        return _reach;
    }

});

var typeAudienceRepo = ({

    Audiences = [{ ...typeAudience() }],
    selectedCustomAudienceId,
    totalMaxReach,
    platform

} = {}) => ({

    Audiences,
    selectedCustomAudienceId,
    totalMaxReach,
    platform,

    // getNextAudienceId() {
    //     return this.nextDirtyAudienceId;
    // },
    // 
    // setNextAudienceId() {
    //     this.nextDirtyAudienceId = (this.nextDirtyAudienceId || 1000) + 1;
    // },

    loadData(data, callback) {
        let _audiences = [];
        data.forEach((aud, index, audArr) => {
            let _aud = typeAudience();
            //aud.audienceMaxReach = totalMaxReach;
            _aud.loadData(aud);
            var o_reach = _aud.getAudienceReachObj();
            _aud.audienceReach = o_reach.reach;
            _audiences.push(_aud);
        });
        this.Audiences = _audiences;
    },

    selectedCustomAudience(callback) {
        return this.get(this.selectedCustomAudienceId, callback);
    },

    get(id, callback) {
        let a = this.Audiences.find(aud => aud.audienceId === id) || null;
        if (callback)
            callback(a);
        return a;
    }

    // save: (audience, callback) => {
    //     callback();
    // },
    // 
    // update: (audience, callback) => {
    //     callback();
    // }
    // 

});

const aud_types = {
    install(Vue, options) {
        Vue.prototype.$TYPES = {
            typeRule,
            typeAudience,
            typeAudienceRepo
        };
    }
};

Vue.use(aud_types);

const popupTabMode = {
    ADD: 'ADD',
    CHOOSE: 'CHOOSE',
    EDIT: 'EDIT'
};

const addTabState = {
    add: { invisible: false, active: true },
    choose: { invisible: false, active: false },
    edit: { invisible: true, active: false },
};

const chooseTabState = {
    add: { invisible: false, active: false },
    choose: { invisible: false, active: true },
    edit: { invisible: true, active: false },
};

const editTabState = {
    add: { invisible: true, active: false },
    choose: { invisible: true, active: false },
    edit: { invisible: false, active: true },
};

var defaultTabState = chooseTabState;

const logicOperators = {
    AND: 'AND',
    OR: 'OR'
};

var MOCK_DATA_ca_all_rules = [{
    ruleId: '05d6cb34-2b2f-496c-a1f7-877ec28ba72c',
    sectionId: 1,
    selectedActionItem: 1,
    selectedEventItem: 3202,
    selectedDays: 1
}, {
    ruleId: '66049571-6bb7-4d75-9d25-571f431217a5',
    sectionId: 1,
    selectedActionItem: 0,
    selectedEventItem: 3245,
    selectedDays: 2
}, {
    ruleId: 'fdb6b3d2-afcf-4590-bc42-7e444c3cf02e',
    sectionId: 1,
    selectedActionItem: 1,
    selectedEventItem: 3244,
    selectedDays: 5
}, {
    ruleId: '8e2e7578-72cd-435a-9928-589a1a98c9a0',
    sectionId: 1,
    selectedActionItem: 1,
    selectedEventItem: 3243,
    selectedDays: 4
}, {
    ruleId: '6b02c646-c169-4384-c694-41f0a29ea288',
    sectionId: 2,
    selectedActionItem: 0,
    selectedEventItem: 3242,
    selectedDays: 2
}, {
    ruleId: '220cd2c3-b230-412d-e54b-6aa9de1ffb21',
    sectionId: 2,
    selectedActionItem: 0,
    selectedEventItem: 3241,
    selectedDays: 5
}, {
    ruleId: 'd9394aa3-4b83-4cc2-877e-b7f812cd209d',
    sectionId: 2,
    selectedActionItem: 0,
    selectedEventItem: 3240,
    selectedDays: 5
}, {
    ruleId: '03b7d626-b4f4-4af4-817b-f16468e04a3e',
    sectionId: 3,
    selectedActionItem: 1,
    selectedEventItem: 3202,
    selectedDays: 4
}, {
    ruleId: 'f4e8c859-47f5-49e6-a2c7-e2f838b94887',
    sectionId: 4,
    selectedActionItem: 0,
    selectedEventItem: 3199,
    selectedDays: 4
}, {
    ruleId: '5ff3a009-1e85-447a-8c44-cf3acb5014fe',
    sectionId: 4,
    selectedActionItem: 1,
    selectedEventItem: 3198,
    selectedDays: 2
    //selectedEqualityItem: 2,
    //selectedTimes: 4
}];

var _MOCK_DATA_ca_all_audiences = [];
var MOCK_DATA_ca_all_audiences = [{
    audienceId: 'd03cccef-2d65-4ed3-cbe0-a979374c0b0d',
    audienceName: 'my audience 1',
    audienceApps: 0,
    audienceRange: 70,
    audienceReach: 135222,
    audienceOperator: 'AND',
    audienceIsDirty: false,
    audienceRules: MOCK_DATA_ca_all_rules.slice(1, 3)
}, {
    audienceId: '1f392561-2786-4056-be45-99c401f5ce45',
    audienceName: 'my audience 2',
    audienceApps: 1,
    audienceRange: 30,
    audienceReach: 25222,
    audienceOperator: 'OR',
    audienceIsDirty: false,
    audienceRules: MOCK_DATA_ca_all_rules.slice(4, 6)
}, {
    audienceId: 'e71ded24-14d9-4fa8-a952-f1856886e723',
    audienceName: 'my audience 3',
    audienceApps: 0,
    audienceRange: 90,
    audienceReach: 6635222,
    audienceOperator: 'AND',
    audienceIsDirty: false,
    audienceRules: MOCK_DATA_ca_all_rules.slice(7)
}];

const state = {

    CustomAudiencesRepo: null,

    current_pba_id: null,
    current_app_pkg: null,
    saved_audience_exists: false,

    selected_audience_exists: false,
    selected_audience_is_dirty: false,
    selected_audience_from_campaign_id: null,
    selected_audience_from_campaign: null,

    _target_apps: [],
    _audience_events: [],
    _audience_actions: [],

    newCustomAudience: null,

    cachedRepoData: null,
    tabsState: defaultTabState,

    total_max_reach: 0

};

const getters = {

    REPO(state) {
        return state.CustomAudiencesRepo || null;
    },

    newCustomAudience(state) {
        return state.newCustomAudience;
    },

    /*
    newCustomAudience(state) {
        if (state.CustomAudiencesRepo) {
            const doneCallback = (a) => { // console.log(JSON.stringify(a)); };
            let currAud = state.CustomAudiencesRepo.get(state.newCustomAudienceId, doneCallback);
            return currAud || { ...typeAudience() };
        }
        else {
            return null;
        }
    },
    */

    selectedCustomAudience(state) {
        return state.CustomAudiencesRepo ? state.CustomAudiencesRepo.selectedCustomAudience() : null;
    },

    getSelectedAudienceState(state) {
        return {
            selected_audience_exists: state.selected_audience_exists,
            selected_audience_from_campaign_id: state.selected_audience_from_campaign_id,
            selected_audience_from_campaign: state.selected_audience_from_campaign
        };
    },

    // getNewCustomAudience(state) {
    //     return state.newCustomAudience || this.getEmptyAudience;
    // },

    getTabsState(state) {
        return state.tabsState;
    },

    getEmptyRule(state) {
        return Object.assign({}, typeRule());
    },

    getEmptyAudience(state) {
        return Object.assign({}, typeAudience({ audienceMaxReach: state.total_max_reach }));
    },

    getAllCustomAudiences(state) {
        return state.CustomAudiencesRepo ? state.CustomAudiencesRepo.Audiences : [];
    },
    
    newCustomAudienceRules(state, getters) {
        return getters.newCustomAudience ? getters.newCustomAudience.audienceRules || [] : [];
    },


    getRulesCount(state, getters) {
        return getters.newCustomAudience ? getters.newCustomAudience.audienceRules ? getters.newCustomAudience.audienceRules.length : 0 : 0;
    },

    getRuleById(state, getters) {

        if (!getters.newCustomAudience) return null;

        return ruleid => getters.newCustomAudience.audienceRules.find((r) => {
            return r.ruleId === ruleid;
        }) || null;
    },

    getRulesInternalOperator(state, getters) {  
        if (getters.newCustomAudience)
            return getters.newCustomAudience.audienceInternalOperator;
        else
            return '';
    },

    getRulesExternalOperator(state, getters) {
        if (getters.newCustomAudience)
            return getters.newCustomAudience.audienceExternalOperator;
        else
            return '';
    },

    getNextRuleId(state, getters) {
        return getters.newCustomAudience.getNextDirtyRuleId();
    },

    getNextSectionId(state, getters) {
        return getters.newCustomAudience.getNextSectionId();
    },

    getNextDirtyRuleId(state, getters) {
        return getters.newCustomAudience.getNextDirtyRuleId();
    },

    target_apps(state) {
        return state._target_apps;
    },

    audience_events(state) {

        //  { pba_id, package, event_id, event_name, reach }
        return state._all_events.filter(ev => state.newCustomAudience.audienceApps === 0 ? true : ev.package.toLowerCase() === model.current_app_pkg.toLowerCase());
    },

    audience_actions(state) {
        return state._audience_actions;
    },

    getAudienceReach(state) {

        const calc = _aud => {

            let audd = typeAudience();
            audd.loadData(_aud);

            let __reachObj = audd.getAudienceReachObj();

            let _reach = {
                // level: avg ? (avg > range * 0.7 ? "too broad" : avg < range * 0.3 ? "too narrow" : "fairly broad") : " --- ",
                level: __reachObj.level,
                precentage: __reachObj.precentage || 0,
                reach: __reachObj.reach || 0
            };

            return _reach;
        };


        return audience => {
            let r = calc(audience);
            return r ? r.reach : 0;
        };
    },


    _getAudienceReach(state) {


        const calc = (_aud) => {

            let audd = typeAudience();
            audd.loadData(_aud);

            let validAudienceRules = audd.audienceRules.filter(a => a.ruleIsValid());

            if (validAudienceRules.length === 0) {
                return {
                    level: null,
                    precentage: 0,
                    reach: 0
                };
            }

            var _max_reach = 0;

            const _getMinInt = arr => arr && arr.length ? arr.reduce((max, value) => value > max ? max : value) : 0;
            const _getMaxInt = arr => arr && arr.length ? arr.reduce((max, value) => value > max ? value : max) : 0;
            const _sumIntArr = arr => arr && arr.length ? arr.reduce((total, value) => total + value) : 0;

            var allevents = JSON.parse(model.eventsCustomAudienceObj.cdc_events_custom_audience_events_json);

            var getEventsReach = _events => _events.map(({ id, days }) => {
                let evt = allevents.find(e => e.id === id);
                let _event_reach = 0;

                switch (days) {

                    case 7:
                        _event_reach = evt.reach * 1;
                        break;
                    case 14:
                        _event_reach = evt.reach * 2;
                        break;
                    case 30:
                        _event_reach = evt.reach * 4;
                        break;

                    default:
                        _event_reach = evt.reach * 1;
                        break;
                }

                return _event_reach;
            });

            if (allevents.length > 0) {
                _max_reach = allevents[0].max_reach;
            }

            var all_events = allevents.map(r => r.id);
            var did_events = validAudienceRules.filter(a => a.selectedActionItem === 1).map(r => { return { id: r.selectedEventItem, days: r.selectedDays }; });
            var didnt_events = validAudienceRules.filter(a => a.selectedActionItem === 0).map(r => { return { id: r.selectedEventItem, days: r.selectedDays }; });

            let did_events_count_max_selected = did_events && did_events.length ? _getMaxInt(getEventsReach(did_events)) : 0;

            let did_events_count_sum_selected = did_events && did_events.length ? _sumIntArr(getEventsReach(did_events)) : 0;
            let didnt_events_count_sum_selected = didnt_events && didnt_events.length ? _sumIntArr(getEventsReach(didnt_events)) : 0;

            let sum = did_events_count_sum_selected - didnt_events_count_sum_selected;

            // let avg_selected = (did_events_count_max_selected + did_events_count_sum_selected) / 2;
            let max_all_eventes = parseInt(_sumIntArr(allevents.map(r => r.reach)) / allevents.map(r => r.reach).length);

            let precentage = parseInt(sum * 100 / max_all_eventes);


            //let didnt_events_count = didnt_events && didnt_events.length ? _sumIntArr(getEventsReach(all_events.filter(evid => didnt_events.indexOf(evid) < 0))) : 0;

            // let min = did_events && did_events.length ? _getMaxInt(getEventsReach(did_events)) : 0;
            // let max = didnt_events && didnt_events.length ? _sumIntArr(getEventsReach(all_events.filter(evid => didnt_events.indexOf(evid) < 0))) : min;
            //let range = sum_all_eventes;
            // 
            // if (max === min) min = 0;
            // 
            // let avg = (max + min) / 2;
            // let avg = did_events_count;

            let _reach = {
                // level: avg ? (avg > range * 0.7 ? "too broad" : avg < range * 0.3 ? "too narrow" : "fairly broad") : " --- ",
                level: precentage > 70 ? "too broad" : precentage < 30 ? "too narrow" : "fairly broad",
                precentage: precentage || 0,
                reach: parseInt(did_events_count_sum_selected || 0)
            };

            // console.log('_reach: ' + JSON.stringify(_reach));

            return _reach;
        };


        return audience => {
            let r = calc(audience);
            return r ? r.reach : 0;
        };
    },

    //potentialReachData(state, getters) {

    //    const calc = audd => {

    //        let reachData = audd.getAudienceReach();

    //        let range = reachData.max - reachData.min;
    //        let avg = (reachData.max - reachData.min) / 2;

    //        return {
    //            level: avg > 7000 ? "fairly broad" : "too narrow",
    //            precentage: avg / range * 100,
    //            reach: avg
    //        };

    //    };

    //    return myaud => calc(myaud);
        
    //}
};

const mutations = {

    initStateMutation(state) {

        let app = model.allUserApps.find(a => a.pba_id === model.currentCampaignObj.App);

        state.current_pba_id = model.currentCampaignObj.App;
        state._target_apps = JSON.parse(model ? model.eventsCustomAudienceObj.cdc_events_custom_audience_target_apps_json : "[]");
        state._all_events = JSON.parse(model ? model.eventsCustomAudienceObj.cdc_events_custom_audience_events_json : "[]");
        state._audience_actions = JSON.parse(model ? model.eventsCustomAudienceObj.cdc_events_custom_audience_action_json : "[]");

        state.total_max_reach = state._all_events && state._all_events.length > 0 ? state._all_events[0].max_reach : 0;

        state.newCustomAudience = { ...typeAudience({ audienceId: Utils.RandomUUID(), audienceMaxReach: state.total_max_reach }) };

        state.CustomAudiencesRepo = typeAudienceRepo();
        model.eventsCustomAudienceObj.Repo.Audiences = model.eventsCustomAudienceObj.Repo.Audiences.map(o => { var a = o; a.audienceMaxReach = state.total_max_reach; return a; });
        state.CustomAudiencesRepo.loadData(model.eventsCustomAudienceObj.Repo.Audiences);
        state.CustomAudiencesRepo.platform = model.camp_platform_name;

        //state.CustomAudiencesRepo.loadData(MOCK_DATA_ca_all_audiences);
        state.CustomAudiencesRepo.selectedCustomAudienceId = model.currentCampaignObj.ca_by_events_selected_audience_id;

        state.saved_audience_exists = model.currentCampaignObj.ca_by_events_has_audience;

        state.selected_audience_from_campaign_id = model.currentCampaignObj.ca_by_events_selected_audience_id;
        state.selected_audience_from_campaign = model.currentCampaignObj.ca_by_events_selected_audience = state.CustomAudiencesRepo.selectedCustomAudience();
        state.selected_audience_exists = state.selected_audience_from_campaign !== null && state.selected_audience_from_campaign.hasOwnProperty('audienceId') ? true : false;

    },
    
    updateStateMutation(state, aud) {

        let repo = model.eventsCustomAudienceObj.Repo;

        state.newCustomAudience = { ...typeAudience({ audienceId: Utils.RandomUUID(), audienceMaxReach: state.total_max_reach }) };

        state.CustomAudiencesRepo = typeAudienceRepo({
            Audiences: repo.Audiences,
            selectedCustomAudienceId: repo.selectedCustomAudience ? repo.selectedCustomAudience.audienceId : null,
            totalMaxReach: state.total_max_reach
        });

        state.CustomAudiencesRepo.loadData(model.eventsCustomAudienceObj.Repo.Audiences);
        state.CustomAudiencesRepo.selectedCustomAudienceId = model.currentCampaignObj.ca_by_events_selected_audience_id;

        state.saved_audience_exists = model.currentCampaignObj.ca_by_events_has_audience;

        state.selected_audience_from_campaign_id = model.currentCampaignObj.ca_by_events_selected_audience_id;
        state.selected_audience_from_campaign = model.currentCampaignObj.ca_by_events_selected_audience = state.CustomAudiencesRepo.selectedCustomAudience();
        //state.selected_audience_exists = state.selected_audience_from_campaign ? true : false;
        state.selected_audience_exists = state.selected_audience_from_campaign !== null && state.selected_audience_from_campaign.hasOwnProperty('audienceId') ? true : false;



    },

    cacheRepoDataMutation(state) {
        state.cachedRepoData = JSON.parse(JSON.stringify(this.getters.REPO));
    },

    undoRepoDataChangesMutation(state) {
        Object.assign(state.CustomAudiencesRepo, { ...state.cachedRepoData });
    },


    setTabModeMutation(state, mode) {
        // let tab = state.popupTabMode || popupTabMode.ADD;

        //defaultTabState = (this.getters.REPO.selectedCustomAudienceId || this.getters.REPO.Audiences.length) ? addTabState : chooseTabState;

        switch (mode) {
            case popupTabMode.ADD:
                state.tabsState = addTabState;
                break;

            case popupTabMode.CHOOSE:
                state.tabsState = chooseTabState;
                break;

            case popupTabMode.EDIT:
                state.tabsState = editTabState;
                break;

            default:
                state.tabsState = addTabState;
                break;
        }

    },

    setNextTempRuleIdMutation(state, newCustomAudience) {
        newCustomAudience.setNextDirtyRuleId();
    },

    setNewCustomAudienceMutation(state, aud) {
        return state.newCustomAudience = aud;
    },

    setSelectedAudienceMutation(state, { aud, is_new, is_dirty }) {

        // let dirty = model.currentCampaignObj.ca_by_events_selected_audience_id !== (aud ? aud.audienceId : null);

        if (aud) {

            model.currentCampaignObj.ca_by_events_selected_audience_id = aud.audienceId;
            model.currentCampaignObj.ca_by_events_selected_audience = aud; //state.CustomAudiencesRepo.get(aud.audienceId);
            state.selected_audience_from_campaign_id = aud.audienceId;
            state.selected_audience_from_campaign = model.currentCampaignObj.ca_by_events_selected_audience;
            state.CustomAudiencesRepo.selectedCustomAudienceId = aud.audienceId;

            state.selected_audience_exists = true;    

            var tempAudObj = (({
                audienceId,
                audienceName,
                audienceApps,
                audienceOperator,
                audienceRules
            }) => ({
                audienceId,
                audienceName,
                audienceApps,
                audienceOperator,
                audienceRules: audienceRules.map((ruleObj) => {
                    let _audienceId = audienceId; // from parent audience
                    return (({
                        ruleId,
                        dirtyRuleId,
                        sectionId,
                        audienceId,
                        selectedActionItem,
                        selectedEventItem,
                        selectedDays
                    }) => ({
                        ruleId: ruleId || dirtyRuleId,
                        sectionId,
                        audienceId: audienceId || _audienceId,
                        selectedActionItem,
                        selectedEventItem,
                        selectedDays
                    }))(ruleObj);
                })
            }))(aud);

            model.currentCampaignObj.ca_by_events_audience_to_save = JSON.stringify(tempAudObj);
            model.currentCampaignObj.ca_by_events_audience_is_new = is_new;

            // console.log(tempAudObj);

        }
        else {

            model.currentCampaignObj.ca_by_events_selected_audience_id = null;
            model.currentCampaignObj.ca_by_events_selected_audience = null;
            state.selected_audience_from_campaign_id = null;
            state.selected_audience_from_campaign = null;
            state.CustomAudiencesRepo.selectedCustomAudienceId = null;
            state.selected_audience_exists = false;      

            model.currentCampaignObj.ca_by_events_audience_to_save = "";
            model.currentCampaignObj.ca_by_events_audience_is_new = false;

        }

        state.selected_audience_is_dirty = is_dirty;
        model.currentCampaignObj.ca_by_events_is_dirty = is_dirty;
        window.setIsDirty();
    },

    addNewRuleMutation(state, payload) {
        payload.newCustomAudience.audienceRules.push(payload.ruleData);
    },


    updateRuleMutation(state, payload) {

        if (payload.context.getters.newCustomAudience) {

            let _rule = payload.context.getters.newCustomAudience.audienceRules.find((r) => {
                return r.ruleId ? r.ruleId === payload.ruleData.ruleId : r.dirtyRuleId === payload.ruleData.dirtyRuleId;
            });
            if (_rule) {
                // console.log('_rule assign: payload.ruleData: ' + JSON.stringify(payload.ruleData));
                Object.assign(_rule, payload.ruleData);
            }
            else {
                // console.log('newCustomAudience.audienceRules.push(payload.ruleData): ' + JSON.stringify(payload.ruleData));
                payload.context.getters.newCustomAudience.audienceRules.push(payload.ruleData);
            }


            /*
             
                     if (payload.context.getters.newCustomAudience) {

                        let _ruleIndex = payload.context.getters.newCustomAudience.audienceRules.indexOf((r) => {
                            return r.ruleId ? r.ruleId === payload.ruleData.ruleId : r.dirtyRuleId === payload.ruleData.dirtyRuleId;
                        });

                        this._vm.$set(payload.context.getters.newCustomAudience.audienceRules, (_ruleIndex > 0 ? _ruleIndex : 0), payload.ruleData);

                    }

             */
        }
    },

    setOperatorsMutation(state, payload) {

        if (payload.newCustomAudience === null || payload.op === "") return;

        switch (payload.op) {
            case logicOperators.AND:
                payload.newCustomAudience.audienceOperator = logicOperators.AND;
                payload.newCustomAudience.audienceInternalOperator = logicOperators.AND;
                payload.newCustomAudience.audienceExternalOperator = logicOperators.OR;
                break;

            case logicOperators.OR:
                payload.newCustomAudience.audienceOperator = logicOperators.OR;
                payload.newCustomAudience.audienceInternalOperator = logicOperators.OR;
                payload.newCustomAudience.audienceExternalOperator = logicOperators.AND;
                break;

            default:
                payload.newCustomAudience.audienceOperator = '';
                payload.newCustomAudience.audienceInternalOperator = '';
                payload.newCustomAudience.audienceExternalOperator = '';
                break;
        }


    },

    clearOperatorsMutation(state) {
        this.getters.newCustomAudience.audienceOperator = '';
        this.getters.newCustomAudience.audienceInternalOperator = '';
        this.getters.newCustomAudience.audienceExternalOperator = '';
    },

    resetOperatorsMutation(state) {
        this.getters.newCustomAudience.audienceOperator = state.cachedRepoData.audienceInternalOperator;
        this.getters.newCustomAudience.audienceInternalOperator = state.cachedRepoData.audienceInternalOperator;
        this.getters.newCustomAudience.audienceExternalOperator = state.cachedRepoData.audienceExternalOperator;
    },

    removeRuleMutation(state, payload) {

        let index = payload.newCustomAudience.audienceRules.findIndex((r) => {
            return payload.ruleid ? r.ruleId === payload.ruleid : r.dirtyRuleId === payload.dirtyruleid;
        });

        payload.newCustomAudience.audienceRules.splice(index, 1);

    },

    addAudienceToRepoAfterCampaignSaveMutation(state, { newAud, repo }) {

        repo.Audiences.push(newAud);

    }
       

    /*
    mutateMutation(state, payload) {

        let property = payload.property;
        let property_value = payload.property_value;
        
        let prop = payload.repo;

        if (property_path) {


            if (property_value) {
                prop = property_value;
                return prop;
            }
            else {
                return prop;
            }

        }

        if (payload.callback)
            payload.callback(prop);


    },
    */
};

const actions = {


    setTabMode(context, mode) {
        context.commit('setTabModeMutation', mode);
    },

    resetRepoDataChanges(context) {
        context.commit('undoRepoDataChangesMutation');
    },

    cacheRepoData(context) {
        // presist current data locally
        context.commit('cacheRepoDataMutation');
    },

    setSelectedAudience(context, { aud, is_new, is_dirty }) {
        context.commit('setSelectedAudienceMutation', { aud, is_new, is_dirty });
    },

    /*
    mutate(context, payload) {
        payload = payload || {};

        let result = null;
        payload.property = context.getters.REPO;
        payload.callback = (p_res) => { result = p_res; };
        context.commit('mutateMutation', payload);

        return result;
    },
    */

    createRule(context, rule) {
        return typeRule(rule);
    },

    setNewCustomAudience(context, aud) {
        context.commit('setNewCustomAudienceMutation', aud);
    },

    removeRule(context, payload) {

        context.dispatch('_removeRule', payload).then(() => {

            if (context.getters.newCustomAudience.audienceRules && context.getters.newCustomAudience.audienceRules.length < 2) {
                context.commit('clearOperatorsMutation');
            }

            if (context.getters.newCustomAudience.audienceRules && context.getters.newCustomAudience.audienceRules.length === 0) {

                context.commit('setNextTempRuleIdMutation', context.getters.newCustomAudience);
                let _ruleData = Object.assign({}, context.getters.getEmptyRule);
                _ruleData.dirtyRuleId = context.getters.getNextDirtyRuleId;
                _ruleData.sectionId = context.getters.getNextSectionId;

                let payload = { ruleData: _ruleData, newCustomAudience: context.getters.newCustomAudience };
                context.commit('addNewRuleMutation', payload);

            }

        });
    },

    _removeRule(context, payload) {
        payload.newCustomAudience = context.getters.newCustomAudience;
        context.commit('removeRuleMutation', payload);
    },
   
    loadStateFromData(context) {
        context.commit('initStateMutation');
        if (context.getters.selectedCustomAudience) {
            //context.commit('setNewCustomAudienceMutation', context.getters.selectedCustomAudience);
            context.commit('setTabModeMutation', popupTabMode.CHOOSE);
        }
        else {
            if (context.getters.getAllCustomAudiences && context.getters.getAllCustomAudiences.length > 0) {
                context.commit('setTabModeMutation', popupTabMode.CHOOSE);
            }
            else {
                context.commit('setTabModeMutation', popupTabMode.ADD);
            }
        }
    },

    setOperators(context, op) {

        let payload = { op: op, newCustomAudience: context.getters.newCustomAudience };
        if (context.getters.newCustomAudience)
            context.commit('setOperatorsMutation', payload);
    },

    clearOperators(context) {
        context.commit('clearOperatorsMutation');
    },

    updateRule(context, ruleData) {

        if (ruleData.ruleId) {
            ruleData.dirtyRuleId = ruleData.ruleId;
        }
        else {
            if (ruleData.dirtyRuleId) {
                ruleData.dirtyRuleId = ruleData.dirtyRuleId;
            }
            else {
                context.commit('setNextTempRuleIdMutation', context.getters.newCustomAudience);
                ruleData.dirtyRuleId = context.getters.getNextDirtyRuleId;
            }
        }

        ruleData.sectionId = ruleData.sectionId || context.getters.getNextSectionId;

        let payload = { ruleData: ruleData, context: context };
        context.commit('updateRuleMutation', payload);
    },

    addSectionRule(context, sectionid) {

        context.commit('setNextTempRuleIdMutation', context.getters.newCustomAudience);

        let _ruleData = Object.assign({}, context.getters.getEmptyRule);
        _ruleData.dirtyRuleId = context.getters.getNextDirtyRuleId;
        _ruleData.sectionId = sectionid;

        let payload = { ruleData: _ruleData, newCustomAudience: context.getters.newCustomAudience };
        context.commit('addNewRuleMutation', payload);

    },

    addNewSectionRule(context) {

        context.commit('setNextTempRuleIdMutation', context.getters.newCustomAudience);

       let _ruleData = Object.assign({}, context.getters.getEmptyRule);
        _ruleData.dirtyRuleId = context.getters.getNextDirtyRuleId;
        _ruleData.sectionId = context.getters.getNextSectionId;

        let payload = { ruleData: _ruleData, newCustomAudience: context.getters.newCustomAudience };
        context.commit('addNewRuleMutation', payload);


    },

    addAudienceToRepoAfterCampaignSave(context, newAud) {

        let aud = model.eventsCustomAudienceObj.Repo.Audiences.find(a => a.audienceId === model.eventsCustomAudienceObj.Repo.selectedCustomAudienceId) || null;

        if (aud === null && newAud !== null) {
            model.eventsCustomAudienceObj.Repo.Audiences.push(newAud);
            context.commit('updateStateMutation', newAud);
        }
        
    },


    /*
    fetchRulesDataRemote(context) {

        return new Promise((resolve, reject) => {

            let dateRange = context.getters.getRevenueTime;
            let currentReport = context.getters.getCurrentReport;

            let fromDateTime = new Date(dateRange.from);
            let toDateTime = new Date(dateRange.to);

            let from = `${fromDateTime.getFullYear()}-${fromDateTime.getMonth() + 1}-${fromDateTime.getDate()}`; //ex: 2019-01-23
            let to = `${toDateTime.getFullYear()}-${toDateTime.getMonth() + 1}-${toDateTime.getDate()}`;

            var request = {};

            Vue.$http.post(caRulesUrls.getRulesData, request).then((response) => {

                let _rulesData = response.data.rulesData;

                if (_rulesData) {
                    context.commit(`${storePrefix}updateRulesData`, _rulesData);
                } else {
                    context.commit(`${storePrefix}updateRulesData`, undefined);
                }

                resolve();

            }).catch((error) => {
                reject();
            });

        });
    },

    fetchRevenueAppDetails(context, payload) {

        return new Promise((resolve, reject) => {
            Vue.$http.post(revenueUrls.getPublisherApp, payload).then((response) => {
                if (response && response.data && response.data[0]) {
                    let app = response.data;
                    context.commit(`${storePrefix}updateAdvertiserAppDetails`, app);
                    resolve();
                } else {
                    reject();
                }
            }).catch((error) => {
                reject();
            });

        });

    },

    updateRevenueOptionsFilters(context, filterId) {
        context.commit(`${storePrefix}updateRevenueOptionsFilters`, filterId);
    },

    setReportType(context, reportType) {
        context.commit(`${storePrefix}setReportType`, reportType);
        context.commit(`${storePrefix}setSessionStorage`);
    },

    setDateRange(context, payload) {
        context.commit(`${storePrefix}setDateRange`, payload);
        context.commit(`${storePrefix}setSessionStorage`);
    },

    removeFilter(context, payload) {
        context.commit(`${storePrefix}removeFilter`, payload);
        context.commit(`${storePrefix}setSessionStorage`);
    },

    */
};

export default {
    state,
    getters,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/components/Campaign/CustomAudience/store/custom_audience_by_events_store.js